import { Component, OnInit } from "@angular/core";
import { Ikr998ErtUsers } from "../../../interfaces/ert-kr998ErtUsers/ert-kr998ertusers";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TrainingType } from "../../../services/administration/trainingtypes/trainingtypes";
import { IFacilityData } from "../../../interfaces/administration/facilityData";
import { ActivatedRoute, Router } from "@angular/router";
import { Kr998ErtUsersService } from "../../../services/kr998ErtUsers/kr998ErtUsers.service";
import { AttendanceType } from "../../../interfaces/ert-kr998ErtUsers/ert-kr998-attendanceType";
import { AttendanceStatus } from "../../../interfaces/ert-kr998ErtUsers/ert-kr998-attendancestatus";
import { title } from "process";
import { LoggedUserService } from "../../../services/common/logged-user.service";

@Component({
  selector: "app-ert-kr998-ert-users-edit",
  templateUrl: "./ert-kr998-ert-users-edit.component.html",
  styleUrl: "",
})
export class ErtKr998ErtUsersEditComponent implements OnInit {
  krForm: FormGroup;
  id: number;
  data: Ikr998ErtUsers;
  facilities: IFacilityData[];
  formErrors: string[] = [];
  trainingTypes = TrainingType;
  attendanceTypes = AttendanceType;
  attendanceStatus = AttendanceStatus;

  facilityId: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private k998ErtUsersService: Kr998ErtUsersService,
    private loggedUserService: LoggedUserService
  ) {
    this.krForm = this.fb.group({
      kr998DetailsId: [{ value: "", disabled: true }],
      attendanceType: ["", Validators.required],
      userErtId: ["", Validators.required],
      cai: [""],
      Kr998Id: [{ value: "", disabled: true }],
      attendanceStatus: [""],
      category: [""],
      memberName: [""],
      hours:"",
      trainingTypes: [""],
      instructorAtTimeOfClass: [false],
      calledBy:[{ value: "", disabled: true }],
      mgcccNumber:[{ value: "", disabled: true }],
      title:[{ value: "", disabled: true }],
      unit: [{value: "", disabled: true}]
    });
  }

  ngOnInit(): void {
    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      this.facilityId = Number(user?.facilityId) || 0;
      this.loadRecord();
    });
  }

  loadRecord(): void {
    this.id = +this.route.snapshot.paramMap.get("id")!;
    this.k998ErtUsersService.getByKr998Id(this.id, this.facilityId).subscribe((data) => {
      this.data = data;
      this.initializeRecord();
    });
  }

  initializeRecord(): void {
    this.krForm.patchValue({
      kr998DetailsId: this.data.kr998DetailsId,
      attendanceType: this.data.attendanceType,
      userErtId: this.data.userErtId,
      cai: this.data.userErt.caiEmail,
      Kr998Id: this.data.kr998Id,
      attendanceStatus: this.data.attendanceStatus,
      category: "",
      memberName: this.data.userErt.fullName,
      hours: this.data.hours,
      trainingTypes: this.getTrainingTypeName(this.data.kr998.trainingType),
      instructorAtTimeOfClass: this.data.instructorAtTimeOfClass,
      calledBy: this.data.userErt.calledBy,
      mgcccNumber: this.data.userErt.mgcccNumber,
      title: "",
      unit:""
    });
  }
  onInstructorAtTimeOfClassChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.krForm.patchValue({
      instructorAtTimeOfClass: checked,
    });
  }

  onSubmit(): void {
    this.formErrors = this.k998ErtUsersService.validate(this.krForm);
    if (this.formErrors.length === 0) {
      const updatedData: Ikr998ErtUsers = {
        ...this.krForm.getRawValue(),
        kr998DetailsId: this.data.kr998DetailsId,
        userErtId: this.data.userErtId,
        isInstructior: this.data.isInstructior,
        instructorAtTimeOfClass: this.krForm.value.instructorAtTimeOfClass,
        userErt: this.data.userErt,
        kr998: this.data.kr998,
      };
      this.k998ErtUsersService.updateERTUser(updatedData, this.facilityId).subscribe(() => {
        this.router.navigate(["/ert-kr998/ert-kr998-view", this.data.kr998Id]);
      });
    }
  }

  onCancel(): void {
    this.router.navigate(["/ert-kr998/ert-kr998-view", this.data.kr998Id]);
  }

  getTrainingTypeName(trainingTypeId: number): string {
    return TrainingType[trainingTypeId];
  }

  getAttendanceTypeKeys(): string[] {
    return Object.keys(this.attendanceTypes).filter(
      (key) => !isNaN(Number(this.attendanceTypes[key]))
    );
  }
  getAttendanceStatusKeys(): string[] {
    return Object.keys(this.attendanceStatus).filter(
      (key) => !isNaN(Number(this.attendanceStatus[key]))
    );
  }
}
